var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_bill_payment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_48",
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    d: "M14.744 8.39031H15.784C17.052 8.39031 17.827 8.78581 18.031 9.58068H14.744V10.266H18.071C17.971 11.2102 17.123 11.817 15.549 11.817H14.749V12.67C16.127 14.0387 17.183 15.2281 18.332 16.5164H19.721C18.497 15.1195 17.268 13.7198 16.121 12.6099C17.987 12.5556 19.17 11.6657 19.316 10.2835H20.884V9.58746H19.294C19.2282 9.03145 18.9291 8.52624 18.467 8.19063H20.874V7.51208H14.744V8.39031Z",
    fill: "#FE6867"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_78"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9,
    y: 19.6735,
    width: 12,
    height: 0.969349,
    rx: 0.484674,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 9.5,
    y: 20.1578,
    width: 11,
    height: 0.0977011,
    stroke: "#39284F",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 9,
    y: 10.4642,
    width: 3,
    height: 0.969349,
    rx: 0.484674,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    x: 9.5,
    y: 10.9489,
    width: 2,
    height: 0.0977011,
    stroke: "#39284F",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_82"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    x: 9,
    y: 14.1479,
    width: 3,
    height: 0.969349,
    rx: 0.484674,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    x: 9.5,
    y: 14.6328,
    width: 2,
    height: 0.0977011,
    stroke: "#39284F",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    x: 9,
    y: 17.8318,
    width: 7,
    height: 0.969349,
    rx: 0.484674,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    x: 9.5,
    y: 18.3164,
    width: 6,
    height: 0.0977011,
    stroke: "#39284F",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_83"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    x: 9,
    y: 21.4181,
    width: 3,
    height: 0.969349,
    rx: 0.484674,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    x: 9.5,
    y: 21.9026,
    width: 2,
    height: 0.0977011,
    stroke: "#39284F",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_80"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    x: 9,
    y: 12.3063,
    width: 4,
    height: 0.969349,
    rx: 0.484674,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    x: 9.5,
    y: 12.7908,
    width: 3,
    height: 0.0977011,
    stroke: "#39284F",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_86"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    x: 7.5,
    y: 5.42383,
    width: 15,
    height: 18.4176,
    rx: 1.5,
    stroke: "#39294F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    d: "M14.744 9.90325H20.91",
    stroke: "#FE6867",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    d: "M14.744 7.96465H20.91",
    stroke: "#FE6867",
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillPayment);
export default __webpack_public_path__ + "static/media/bill_payment.906b7481ef232d5baaa16771c6a2b0af.svg";
export { ForwardRef as ReactComponent };